import React, {Component} from "react";
import {Button, notification} from "antd";
import { Row, Col } from 'antd';
import {connect} from "react-redux";
import {setCardId} from "actions";
import _ from 'i18n';
import {
  mangoPayCallback,
  cardWebPayin,
  deactivateCard,
  FeedMangoWalletForOrganizationPayIn,
  getOrganizationCardList,
  mangoPayCallbackForOrganization
} from "../../../actions/thunks/mangoPay";
import {showSpinner, desactivateCard} from "../../../actions/actions/mangoPay";
import CardListFeetching from "../../feetching/mangoPay/CardListFeetching";
import valid from 'card-validator'
import DeleteCardConfirmation from "../../paymentModes/DeleteCardConfirmation";

const openNotificationWithIcon = (type, description, message) => {
  notification[type]({
    message: message,
    description:
    description,
    style: {
      marginTop: 120,
    },
  });
};

const type = {
  v4: {
    httpsUrl: "https://api.ipify.org/"
  },
  v6: {
    httpsUrl: "https://api6.ipify.org/"
  }
};

class UserCardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      showInputRegistrationCard : false,
      pathImageLogo : "",
      ipAdress : "",
      try: 5,
      id:"",
      displayConfirmationModal:false,
    };
  }

  async componentDidMount() {
    this.props.getOrganizationCardList(this.props.currentClient.id);

    this.setState({ipAdress : await this.getIp("v4") || JSON.parse(await this.getIpJsonTest())['ip']})
  }

  async getIp (version)  {
    const data = type[version];
    try {
      const response = await fetch(data.httpsUrl);
      const ip = response.text();
      return ip;
    } catch (e) {
      if(this.state.try > 0) {
        this.setState({try : this.state.try-1})
        return await this.getIp(version)
      }
      return null;
    }
  };

  async getIpJsonTest ()  {
    try {
      const response = await fetch("http://ip.jsontest.com/");
      const ip = response.text();
      return ip;
    } catch (e) {
      return null;
    }
  };

  componentDidUpdate(prevProps) {
    if(prevProps.userCardListReducer !== this.props.userCardListReducer && this.props.userCardListReducer.items.length > 0) {
      this.setState({value : this.props.userCardListReducer.items[0].Id})
      this.props.setCardId(this.props.userCardListReducer.items[0].Id);

    }
  }

  onChange = e => {
    this.setState({
      value: e.target.value,
    });
    this.props.setCardId(e.target.value);
  };

  payinWithCard = (Id) => {
    const {orderId, amount, isCreditNote, creditNoteId, isRefund, redirectionURL} = this.props;
    this.props.showSpinner(true)

    const params = {
      'adressIp' :  this.state.ipAdress,
      'javaEnabled' : window.navigator.javaEnabled(),
      'Language' : window.navigator.language,
      'userAgent' : window.navigator.userAgent,
      'timeZoneOffset' : new Date().getTimezoneOffset(),
      'colorDepth' : screen.colorDepth,
      'screenHeight' : screen.height,
      'screenWidth' : screen.width,

    }
    if(Id!== null) {
      this.props.FeedMangoWalletForOrganizationPayIn(orderId, amount,Id, false, params, isCreditNote, creditNoteId, isRefund, redirectionURL, this.props.currentClient.id, this.props.user.id).then(res => {
        if(res.data.data.result == "failed") {
          window.open(res.data.data.redirect_url,"_self")
          this.props.showSpinner(false)

        } else {
          if(res.data.data.secureMode == true) {
            window.location.assign(res.data.data.redirect_url);
          } else {
            // lancer le thunk pour le post paiement processing
            this.props.mangoPayCallbackForOrganization(res.data.data.orderId, res.data.data.transaction_id, 0, creditNoteId, isCreditNote, amount, isRefund, redirectionURL, this.props.user.id).then((res) => {
              //ajouter unr notif si le peiement est ok avant de faire la redirection
              if(res.data){
                window.location.assign(res.data.redirectionUrl);
              }
            })
          }
        }
      })
    }

  }

  deactivateCard = (Id) => {
    this.props.showSpinner(true)
    this.hideConfirmationModal();
    this.props.deactivateCard(Id).then(res => {
      if(!res.data.data.success) {
        this.props.showSpinner(false)
        openNotificationWithIcon('error', _('incompleteOperation'), _('error'))
      } else {
        this.props.desactivateCard(Id);
        this.props.showSpinner(false)
      }
    })
  }

  showDeleteModal = (id) => {
    this.setState({
      id: id,
      displayConfirmationModal:true,
    });
  };

  hideConfirmationModal = () => {
    this.setState({
      displayConfirmationModal:false,
    });
  };

  renderCart = ({cardDetails , isDeleted}) => {

    //remplacer les X par 1 pour savoir le type de la carte
    let finalAlias = cardDetails.Alias.split("X").join("1");

    var numberValidation = valid.number(finalAlias);
    let pathImageLogo = "";

    if (numberValidation.card) {
      if(numberValidation.card.type == "visa") {
        pathImageLogo =  "/img/icons/visa.svg";
      }

      else if (numberValidation.card.type == "mastercard") {
        pathImageLogo =  "/img/icons/mastercard (1).svg";
      }

      else if (numberValidation.card.type == "maestro") {
        pathImageLogo =  "/img/icons/maestro (2).svg";

      } else {
        pathImageLogo =  "";
      }
    }

    return (
      <Row className={'user-card-container mb-3 flex'}>
        <Col span={2} className={'h-full flex justify-center items-center'}>
          {pathImageLogo !== "" ? <span><img src={pathImageLogo} className={'card-type-img'}/> </span> : null}
        </Col>
        <Col span={8}><div className={'h-full flex items-center'}>{cardDetails.Alias}</div></Col>
        <Col span={3}><div className={'h-full flex items-center'}>{cardDetails.ExpirationDate.substr(0, 2)+"/"+cardDetails.ExpirationDate.substr(2)}</div></Col>
        <Col span={9} className={'h-full flex justify-center items-center'}>
          <button key={cardDetails.Id} type="button" onClick={() => this.payinWithCard(cardDetails.Id)} className={'user-card-button card-list flex items-center ' + (this.props.isCommunity ? 'community-theme' : '')}>{_('Payer-avec-cette-carte')}</button>
        </Col>
        {isDeleted ? <Col span={2} className={'flex justify-center'}><img src={"/img/icons/delete-user-card.svg"} onClick={() => this.showDeleteModal(cardDetails.Id)} className={'card-delete-img'}/></Col> : null }
      </Row>
    )
  }

  render() {
    if (this.props.userCardListReducer.fetching) {
      return <CardListFeetching />
    }

    return (
      <div>
      { this.props.userCardListReducer.items && this.props.userCardListReducer.items.length > 0 ? <div>
          {this.props.userCardListReducer.items.map(this.renderCart)}
        <DeleteCardConfirmation id={this.state.id} visible={this.state.displayConfirmationModal} hideModal={this.hideConfirmationModal} deleteCard={this.deactivateCard}/>
        </div>
        : null}
    </div>);
  }
}

const mapStateToProps = state => ({
  userCardListReducer : state.userCardListReducer,
  orderLines: state.orderLines,
  currentClient: state.auth.currentClient,
  user: state.auth.user,
});

const mapDispatchToProps = {
  setCardId,
  showSpinner,
  cardWebPayin,
  mangoPayCallback,
  deactivateCard,
  desactivateCard,
  FeedMangoWalletForOrganizationPayIn,
  getOrganizationCardList,
  mangoPayCallbackForOrganization,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCardList);



// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/UserCardList.js